// language=GraphQL
export const ALL_AGE_GROUP_SETTINGS_QUERY = `query Query($withAgeGroups: Boolean = false) {
  ageGroupSettings: allTravelPricingAgeGroupSettings {
    id
    freeUntilAge
    ageGroups @include(if: $withAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
  }
}`

// language=GraphQL
export const SINGLE_AGE_GROUP_SETTINGS_QUERY = `query Query($id: ID!, $withAgeGroups: Boolean = false) {
  ageGroupSettings: travelPricingAgeGroupSettings(id: $id) {
    id
    freeUntilAge
    ageGroups @include(if: $withAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
  }
}`

// language=GraphQL
export const CREATE_AGE_GROUP_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelPricingAgeGroupSettingsInput, $withAgeGroups: Boolean = false) {
    ageGroupSettings: createTravelPricingAgeGroupSettings(input: $input) {
      id
      freeUntilAge
      ageGroups @include(if: $withAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUP_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingAgeGroupSettingsInput, $withAgeGroups: Boolean = false) {
    ageGroupSettings: updateTravelPricingAgeGroupSettings(input: $input) {
      id
      freeUntilAge
      ageGroups @include(if: $withAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUP_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingAgeGroupSettingsInput) {
    deleteTravelPricingAgeGroupSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AGE_GROUP_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingAgeGroupSettingsInput) {
    forceDeleteTravelPricingAgeGroupSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: addTravelPricingAgeGroupSettingsAgeGroupsInput) {
    addTravelPricingAgeGroupSettingsAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const REMOVE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: removeTravelPricingAgeGroupSettingsAgeGroupsInput) {
    removeTravelPricingAgeGroupSettingsAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const CREATE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: createTravelPricingAgeGroupSettingsAgeGroupsInput) {
    createTravelPricingAgeGroupSettingsAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: deleteTravelPricingAgeGroupSettingsAgeGroupsInput) {
    deleteTravelPricingAgeGroupSettingsAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUP_SETTINGS_AGE_GROUPS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelPricingAgeGroupSettingsAgeGroupsOrderInput) {
    updateTravelPricingAgeGroupSettingsAgeGroupsOrder(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const AGE_GROUP_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelPricingAgeGroupSettingsDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
